import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Typography, Toolbar, Box } from '@mui/material'

import logoBlue from 'assets/markaaz_logo_blue.png'
import logoWhite from 'assets/markaaz_logo_white.png'
import routes from 'routes'
import Button from 'components/Common/Button'
import { SECONDARY_BUTTON } from 'themes/theme'
import { styled } from '@mui/material/styles'

const signUpState = {
  text: 'Already have an account?',
  buttonText: 'Sign In',
  navigateTo: '/auth',
}
const signInState = {
  text: 'Don’t have an account?',
  buttonText: 'Join Now',
  navigateTo: routes.auth.signUp,
}
const publicState = {
  text: '',
  buttonText: 'Sign In',
  navigateTo: '/auth',
}

const AppBarStyle = styled(Box)(({ theme }) => ({
  background: 'transparent',
  boxShadow: 'none',
  width: '100%',
  [theme.breakpoints.down(813)]: {
    background: 'rgb(248, 250, 251)',
  },
}))

const sx = {
  text: {
    marginRight: theme => theme.spacing(2),
    fontSize: '14px',
    fontWeight: 'lighter',
    [theme => theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  toolbar: {
    minHeight: '76.9px',
    background: '#ffffff',
    justifyContent: 'space-between',
  },
  toolbarLoggedOut: {
    minHeight: '76.9px',
    background: 'transparent',
    justifyContent: 'space-between',
  },
  logo: {
    width: '108px',
    height: '27.69px',
    [theme => theme.breakpoints.down(813)]: {
      display: 'none',
    },
  },
  logoBlue: {
    width: '108px',
    height: '27.69px',
    [theme => theme.breakpoints.down(813)]: {
      display: 'block',
    },
  },
};

const LoggedOutControls = ({ publicPage }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [state, setState] = useState(signInState)
  const [bg, setBg] = useState('transparent')
  const dispatch = useDispatch()

  const setBG = useCallback(() => {
    if (publicPage) setBg('rgb(248, 250, 251)')
    else window.pageYOffset > 0 ? setBg('rgb(248, 250, 251)') : setBg('transparent')
  }, [publicPage])

  const toMarkaaz = useCallback(() => {
    window.location.replace(`${"https://markaaz.com"}`)
  }, [])

  useEffect(() => {
    // TODO: rewrite/improve maybe
    const isSignUpLocation = location.pathname === routes.auth.signUp
    let nextState = isSignUpLocation ? { ...signUpState } : { ...signInState }
    nextState = publicPage ? publicState : nextState
    if (publicPage) setBg('rgb(248, 250, 251)')

    setState(nextState)
    window.addEventListener('scroll', setBG, { passive: true })
    return () => {
      window.removeEventListener('scroll', setBG)
    }
  }, [location, setBG, publicPage])

  const navigateToPage = useCallback(() => {
    dispatch({ type: 'clearError' })
    navigate(state.navigateTo)
  }, [state, dispatch, navigate])

  const navigateToSingUpPage = useCallback(() => {
    dispatch({ type: 'clearError' })
    navigate(routes.auth.signUp)
  }, [dispatch, navigate])

  return (
    // <AppBar position="fixed">
    <AppBarStyle position='fixed'>
      <Toolbar sx={sx.toolbarLoggedOut} style={{ backgroundColor: bg }}>
        <Link to={routes.home} onClick={toMarkaaz}>
          {bg === 'transparent' && <Box component="img" src={logoWhite} sx={sx.logo} alt="Markaaz" />}
          {!bg.includes('transparent') && <Box component="img" src={logoBlue} sx={sx.logoBlue} alt="Markaaz" />}
        </Link>
        <Box display="flex" alignItems="center">
          <Typography color="textPrimary">
            <Box sx={sx.text}>{state.text}</Box>
          </Typography>
          {state.buttonText === publicState.buttonText && state.text === publicState.text && (
            <Button type={SECONDARY_BUTTON} role="link" onClick={navigateToSingUpPage}>
              Join Now
            </Button>
          )}
          <Button type={SECONDARY_BUTTON} role="link" onClick={() => navigateToPage()}>
            {state.buttonText}
          </Button>
        </Box>
      </Toolbar>
    </AppBarStyle>
    // </AppBar>
  )
}

export default LoggedOutControls
